import tippy from 'tippy.js';

const $ = require('jquery');

export default {
  init() {
    tippy('.js-tooltip', {
      allowHTML: true
    });
  }
};
